import React, {useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {useCliff} from "../../hooks/useCliff";
import {useRouteMedias} from "../../hooks/useRoute";
import {ApiUrls} from "../../config/urls";

const SaveCliffComponent = ({i18n, slug, user, setStatus}) => {
    const url = ApiUrls.CLIFF.replace('{lng}', i18n.language).replace('{slug}', slug);
    const { status, data: route } = useCliff(url, slug, user, 0);
    const { status: statusMedias, fetchStatus: fetchStatusMedias, data: medias, error: errorMedias } = useRouteMedias(url + '/medias', route, slug, user);

    useEffect(() => {
        if (setStatus !== undefined) {
            if (status !== "success" && data) {
                setStatus("success");
            } else {
                setStatus(status);
            }
        }
    }, [status]);

    return (<></>);
};

export default withTranslation()(SaveCliffComponent);